import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { PAYMENT_METHODS_QUERY, PaymentMethodsQuery } from '../usePaymentMethodsQuery';
import {
  DELETE_PAYMENT_METHOD_MUTATION,
  DeletePaymentMethodMutation,
  DeletePaymentMethodMutationVariables
} from './deletePaymentMethodMutation.rest';

export const useDeletePaymentMethodMutation = (id: string) => {
  const [mutate, { loading, error }] = useMutation<
    DeletePaymentMethodMutation,
    DeletePaymentMethodMutationVariables
  >(DELETE_PAYMENT_METHOD_MUTATION, {
    update: (cache, { data }) => {
      if (!data) return;

      const cachedData = cache.readQuery<PaymentMethodsQuery>({ query: PAYMENT_METHODS_QUERY });

      if (!cachedData) return;

      cache.writeQuery<PaymentMethodsQuery>({
        query: PAYMENT_METHODS_QUERY,
        data: {
          paymentMethods: {
            __typename: 'RestPaymentMethods',
            data: cachedData.paymentMethods.data.filter(method => method.id !== id)
          }
        }
      });
    }
  });

  const handleDelete = useCallback(() => {
    return mutate({ variables: { id } });
  }, [mutate, id]);

  return [handleDelete, { loading, error }] as const;
};
